export const ENV = 'prod';
export const GENERIC_URL = {
  local: {
    api: 'http://192.168.109.155:6690/',
    core: 'https://sit.ambslot-api.com/',
    apiHub: 'https://api-staging.ambprovider-hub.com/',
    centralApi: 'https://central-sit-api.ambplay.com/',
    socket: 'https://skt-staging.ambslot-api.com/',
    bonus: 'https://angpow-dev.pgslot.cc/',
    result: 'https://report-staging.ambslot.com/',
    user: 'https://staging.ambslot-api.com/report/user-online',
    dolly: 'https://web-api-sit.ambslot-api.com/angpow/legendofdolly/report',
    pg: 'https://web-api-sit.pgslot-api.com/',
    pgc: 'http://localhost:6692/',
    ambsupergames: 'http://localhost:7774/',
    ambpoker: 'http://localhost:6699/'
  },
  dev: {
    api: 'https://web-api-sit.ambslot-api.com/',
    core: 'https://sit.ambslot-api.com/',
    apiHub: 'https://api-staging.ambprovider-hub.com/',
    centralApi: 'https://central-sit-api.ambplay.com/',
    socket: 'https://skt-sit.ambslot-api.com/',
    bonus: 'https://angpow-dev.pgslot.cc/',
    result: 'https://report-staging.ambslot.com/',
    user: 'https://sit.ambslot-api.com/report/user-online',
    dolly: 'https://web-api-sit.ambslot-api.com/angpow/legendofdolly/report',
    pg: 'https://web-api-sit.pgslot-api.com/',
    pgc: 'https://api-agent.pgs-demo.com/',
    ambsupergames: 'https://web-api-sit.ambprovider-hub.com/',
    ambpoker: 'https://web-api-sit.ambpoker-api.com/'
  },
  uat: {
    api: 'https://web-api-uat.ambslot-api.com/',
    core: 'https://uat.ambslot-api.com/',
    apiHub: 'https://api-staging.ambprovider-hub.com/',
    centralApi: 'https://central-uat-api.ambplay.com/',
    socket: 'https://skt-uat.ambslot-api.com/',
    bonus: 'https://angpow-dev.pgslot.cc/',
    result: 'https://report-staging.ambslot.com/',
    user: 'https://staging.ambslot-api.com/report/user-online',
    dolly: 'https://uat.ambslot-api.com/angpow/legendofdolly/report',
    pg: 'https://web-api-uat.pgslot-api.com/',
    pgc: 'https://api-agent.pgs-demo.com/',
    ambsupergames: 'https://web-api-uat.ambprovider-hub.com/',
    ambpoker: 'https://web-api-uat.ambpoker-api.com/'
  },
  prod: {
    api: 'https://web-api-prod.ambslot-api.com/',
    core: 'https://prod.ambslot-api.com/',
    apiHub: 'https://api-prod.ambprovider-hub.com/',
    centralApi: 'https://central-uat-prod.ambplay.com/',
    socket: 'wss://skt-prod.ambslot-api.com/',
    bonus: 'https://rp99qvzxw0.execute-api.ap-southeast-1.amazonaws.com/angpow-prod/',
    result: 'https://report.ambslot.com/',
    user: 'https://prod.ambslot-api.com/report/user-online',
    dolly: 'https://prod.ambslot-api.com/angpow/legendofdolly/report',
    pg: 'https://pgslot-web-api-prod.pgslot-api.com/',
    pgc: 'https://agent.pgf-asw0zzz.com/',
    ambsupergames: 'https://web-api-prod.ambprovider-hub.com/',
    ambpoker: 'https://web-api-prod.ambpoker-api.com/'
  }
};

export const BASE_URL = GENERIC_URL[ENV].api;
export const CORE_URL = GENERIC_URL[ENV].core;
export const API_HUB_URL = GENERIC_URL[ENV].apiHub;
export const API_CENTRAL_URL = GENERIC_URL[ENV].centralApi;
export const SOCKET_URL = GENERIC_URL[ENV].socket;
export const BONUS_URL = GENERIC_URL[ENV].bonus;
export const RESULT_URL = GENERIC_URL[ENV].result;
export const USER_URL = GENERIC_URL[ENV].user;
export const DOLLY_URL = GENERIC_URL[ENV].dolly;
export const PG_URL = GENERIC_URL[ENV].pg;
export const PGC_URL = GENERIC_URL[ENV].pgc;
export const AMB_SUPER_GAMES_URL = GENERIC_URL[ENV].ambsupergames;
export const AMB_POKER_URL = GENERIC_URL[ENV].ambpoker;
export const M_GET = 'GET';
export const M_POST = 'POST';
export const M_PUT = 'PUT';
export const M_DELETE = 'DELETE';
export const M_PATCH = 'PATCH';

// AUTH
export const LOGIN = 'auth/login/agent';
export const REFRESH_TOKEN = 'auth/refresh';
export const VERIFY_TICKET = 'auth/sso/verify-ticket';

// subpass
export const FIND_SUBPASS = 'auth/sub-password/find';
export const CREATE_SUBPASS = 'auth/sub-password/create';
export const VER_SUBPASS = 'auth/sub-password/verify';

// 2FA (Google Authenticator) — ADMIN / SUPERADMIN
export const TWO_FA_SETUP_ENROLL = 'auth/2fa/setup-enroll';
export const TWO_FA_ENABLE_ENROLL = 'auth/2fa/enable-enroll';
export const TWO_FA_VERIFY = 'auth/2fa/verify';
export const TWO_FA_STATUS = 'auth/2fa/status';
export const TWO_FA_SETUP = 'auth/2fa/setup';
export const TWO_FA_ENABLE = 'auth/2fa/enable';
export const TWO_FA_DISABLE = 'auth/2fa/disable';

// USER
export const USERS = 'user/list';
export const GET_USERS_DOWNLINE = 'user/search';
export const USERS_HISTORY = 'user/history';
export const USERS_BALANCE = 'user/balance';
export const USERS_SUBAGENT = 'user/subagent/list';
export const USERS_ACTIVATE = 'user/activate';
export const GET_PROFILE = 'user/profile/get/';
export const UPDATE_PROFILE = 'user/profile/update/';
export const RESET_PASSWORD = 'user/password/reset';
export const UPDATE_COMMISSION = 'user/commission';
export const USERS_GENERATE = 'user/generate';
export const USERS_CREATE = 'user/register';
export const GET_PTSUBAGENT = 'user/ptsubagent';
export const UPDATE_SHOW_CURRENCY_SIGNS = 'user/update/currency-sign';
export const FETCH_LOG_AGENT = 'user/active';
export const USERS_SHEET = 'user/member/list/csv';
export const UPDATE_SUSPEND_BY_GAME = 'user/update/suspend-by-game';

// PREFIX
export const CHECK_PREFIX = 'prefix';

// GAME
export const GET_GAMES = 'game/list';
export const EDIT_DEMO_URL = 'game/edit/demo';
export const GAME_MAINTENANCE = 'game/maintenance';
export const MAINTENANCE_ALL_SOCKET = 'game/set/maintenance/allprovider';
export const MAINTENANCE_GAMES_SOCKET = 'game/set/maintenance';
export const GAME_VERSION = 'game/version';

// VERSION
export const GET_TRANSACTIONS = 'version';
export const EDIT_TRANSACTION = 'version/update';
export const EDIT_VERSION_MASCOT = 'version/mascot/update';

// REPORT
export const GET_GETGAMES = 'report/winlose/getGames';
export const TRANSACTION_REPORT = 'report/result';

export const WINLOSE_REPORT = 'report/winlose/simple';
export const WINLOSE_REPORT_NEW = 'report/winlose/simple/new/v2';
export const WINLOSE_REPORT_NIGHTLY = 'report/winlose/simple/new/v3';
export const WINLOSE_REPORT_LOGS = 'report/winlose/simple/logs';
export const WINLOSE_REPORT_NEW_LOGS = 'report/winlose/simple/log-v2';

export const GAME_REPORT = 'report/game/v2';
export const GAME_REPORT_NIGHTLY = 'report/game/v3';
export const GAME_REPORT_REDIS = 'report/game/report';
export const GAME_REPORT_ELASTIC = 'report/game/elastic';
export const GAMES_SHEET = 'report/game/csv';

export const HIGH_VALUE_REPORT = 'report/high-value';
export const PROVIDER_REPORT = 'report/winlose/provider';
export const PROVIDER_TYPE_REPORT = 'report/winlose/provider/type';

export const WINLOSE_REPORT_MECHANIC = 'report/mechanic/winlose';
export const WINLOSE_RANGE_DATE_REPORT_LOGS_MECHANIC = 'report/mechanic/daylogs';
export const WINLOSE_LOG_ELASTIC_MECHANIC = 'report/mechanic/elastic-log';
export const GET_MECHANIC_GAME_REPORT = 'report/mechanic/game';
export const GAME_ANALYTICS_REPORT = 'report/game/analyze';
export const GAME_SESSION_ANALYZE_REPORT = 'report/game/session/analyze';

export const GAME_ANALYTICS_DOWNLOAD_REPORT_CSV = 'report/game/analyze/csv';
export const GAME_SESSION_DOWNLOAD_REPORT_CSV = 'report/game/session/analyze/csv';

export const INVOICE_REPORT = 'report/winlose/invoice';
export const FECTH_AGENT = 'report/winlose/fetchAgent';
export const GENERATE_EXCEL_INVOICE = 'report/winlose/invoice/excel';

export const WINLOSE_ROUND_AMBSUPERGAME = 'report/round-history';
export const WINLOSE_RANGE_DATE_REPORT_LOGS = 'report/winlose/dayLogs';
export const WINLOSE_LOG_ELASTIC = 'report/winlose/elastic-log';
export const WINLOSE_DOWNLOAD_REPORT_CSV = 'report/financial/csv';
export const FETCH_ROUND_ID = 'report/search/transaction';

// RESULT / HISTORY
export const WINLOSE_RESULT = 'result';
export const WINLOSE_ROUND_LOG = 'history/round-history';

// PERMISSION
export const UPDATE_PERMISSION = 'user-permission/update';

// PLAYER / ONLINE
export const PLAYER_ONLINE = 'player/online';
export const PLAYER_ONLINE_LIST = 'player/online/list';
export const GET_USER_ONLINE = 'agent/online-users';

// PARTNER
export const GET_TRANSFER_KEY = 'partner/transfer/fetch';
export const UPDATE_TRANSFER_KEY = 'partner/transfer/edit';
export const GET_SEAMLESS_KEY = 'partner/seamless/fetch';
export const UPDATE_SEAMLESS_KEY = 'partner/seamless/edit';

// WALLET
export const TRANSFER = 'wallet/credit/refill';
export const WITHDRAW = 'wallet/credit/deduct';
export const GET_STATEMENT = 'wallet/statement';
export const GET_STATEMENT_DETAIL = 'wallet/statement/detail';
export const CURRENCY_RATE = 'wallet/rate';
export const STATEMENT_SHEET = 'wallet/statement/csv';

// INVOICE
export const GET_RATE = 'rate/fetch/rate';
export const WALLET_ADDRESS = 'invoice/wallet';
export const CUSTOMER_GROUP = 'invoice/customer-group';
export const EXPORT_INVOICE = 'invoice/export';

// INVITE FRIEND
export const INVITE_FRIEND_FETCH = 'invite/friend/fetch';
export const INVITE_FRIEND_EDIT = 'invite/friend/edit';

// BONUS
export const BONUS_GET_SUB_USERS = 'key/fetch';
export const BONUS_GET_MAIN_USER = 'key/fetch/product';
export const BONUS_GET_LISTS_SYSTEM = 'agent/generalConfig/fetch';
export const BONUS_SELECT_SYSTEM = 'agent/generalConfig/select';
export const BONUS_UPDATE_CONFIGS = 'agent/generalConfig/update';
export const BONUS_SELECT_ACTIVATE_SYSTEM = 'agent/generalConfig/activeFeature';
export const BONUS_ACTIVATE_ALL_SYSTEM_BY_AGENT = 'agent/generalConfig/active';
export const BONUS_ACTIVATE_GLOBALE_SYSTEM = 'agent/generalConfig/activeGlobal';
export const BONUS_ACTIVATE_MAINTENANCE = 'agent/generalConfig/maintenance';
export const BONUS_ACTIVATE_MAINTENANCE_AGENT = 'agent/generalConfig/maintenanceAgent';
export const BONUS_GET_HISTORY_CONFIG = 'agent/generalConfig/history/fetch';
export const BONUS_DELETE_HISTORY_CONFIG = 'agent/generalConfig/history/delete';
export const BONUS_GET_LOG = 'agent/report/angpow';
export const BONUS_GET_LOG_DETAIL = 'agent/report/angpowTransaction';

// SUGGESTION
export const SUGGESTION_GET_TOPIC = 'suggestion/fetch';
export const SUGGESTION_CREATE_TOPIC = 'suggestion/create';
export const SUGGESTION_EDIT_TOPIC = 'suggestion/edit';
export const SUGGESTION_DELETE_TOPIC = 'suggestion/delete';
export const SUGGESTION_GET_REPORT = 'suggestion/report';
export const SUGGESTION_SUBMIT = 'suggestion/submit';
export const SUGGESTION_SHEET = 'suggestion/sheet';

// DASHBOARD
export const DASHBOARD = 'dashboard/v2';
export const DASHBOARD_MEMBER = 'dashboard/member';

// ANNOUNCEMENT
export const ANNOUNCEMENT_CREATE = 'announcement/create';
export const ANNOUNCEMENT_UPDATE = 'announcement/update';
export const ANNOUNCEMENT_LIST = 'announcement/list';
export const ANNOUNCEMENT_DELETE = 'announcement/delete';

// AGENT BANNER
export const AGENT_BANNER_CREATE = 'agentbanner/create';
export const AGENT_BANNER_UPDATE = 'agentbanner/update';
export const AGENT_BANNER_LIST = 'agentbanner/list';
export const AGENT_BANNER_DELETE = 'agentbanner/delete';

// BANK ACCOUNT
export const BANKACCOUNT_LIST = 'bankaccount/list';
export const BANKACCOUNT_CREATE = 'bankaccount/create';
export const BANKACCOUNT_UPDATE = 'bankaccount/update';
export const BANKACCOUNT_DELETE = 'bankaccount/delete';
export const BANK_NAME_LIST = 'bankaccount/bank/list';

// SOCIAL
export const SOCIAL_FETCH = 'social/fetch';
export const SOCIAL_EDIT = 'social/edit';

// PROMOTION
export const PROMOTION_LIST = 'promotion/list';
export const PROMOTION_CREATE = 'promotion/create';
export const PROMOTION_UPDATE = 'promotion/update';
export const PROMOTION_DELETE = 'promotion/delete';

// DOCUMENT / INVOICE
export const GENERATE_PDF_INVOICE = 'invoice/exportpdf';
export const DOCUMENT_DOWNLOAD = 'document/download';
export const DOCUMENT_FETCH = 'document/fetch';
export const DOCUMENT_CREATE = 'document/create';
export const DOCUMENT_UPDATE = 'document/update';
export const DOCUMENT_DELETE = 'document/delete';

// ADMIN
export const FETCH_RESETPASS_LOG = 'admin/fetchlog';
export const FIND_USER_SUBPASS = 'admin/find-user';
export const RESET_SUBPASS = 'admin/reset';
export const FETCH_RESET_SUBPASS_LOG = 'admin/logs';
export const FETCH_UPDATE_COMMISSION_LOG = 'admin/commission-logs';
export const USER_SEAMLESS_PROBLEM_ADD = 'admin/user-seamless/add';
export const USER_SEAMLESS_PROBLEM_FETCH = 'admin/user-seamless/fetch';
export const USER_SEAMLESS_PROBLEM_REMOVE = 'admin/user-seamless/remove';
export const USER_SEAMLESS_PROBLEM_SEARCH = 'admin/user-seamless/search';
export const FETCH_LOG_ACTIVITY = 'admin/activity-log';
export const FETCH_LOG_ACTIVITY_DETAIL = 'admin/activity-log/detail';
export const FETCH_LOG_TRACKING = 'admin/tracking';

// POINT
export const FETCH_POINT = 'point/report';
export const FETCH_POINT_LOG = 'point/report/log';

// COIN
export const FETCH_COIN = 'point/report/coin';
export const FETCH_COIN_LOG = 'point/report/coin/log';

// MARKETING
export const MARKETING_FETCH = 'marketing/fetch';
export const UPDATE_FEATURE = 'marketing/setfeature';

// Marketing for mascot
export const UPDATE_FEATURE_MASCOT = 'mascot/update/agent/feature';
export const UPDATE_AGENT_MASCOT = 'mascot/update/agent';

// Marketing for angpow
export const UPDATE_FEATURE_ANGPOW = 'angpow/update';

// SUPPORT
export const SUPPORT_GET_USER = 'support/get/user';
export const SUPPORT_EDIT_USER = 'support/edit/user';
export const SUPPORT_GET_BET = 'support/get/bettransaction';

// SETTING
export const SETTING_GET = 'setting/get';
export const SETTING_UPDATE = 'setting/update';

// LOBBY SETTING
export const LOBBY_SETTING_GET = 'config/fetch';
export const LOBBY_SETTING_SET = 'config/set';
export const LOBBY_SETTING_UPDATE = 'config/edit';
export const LOBBY_CONFIG_HEADER = 'whitelabel/lobby/config/header';
export const AGENT_CONFIG_HEADER = 'whitelabel/agent/config/header';
export const LOBBY_CONFIG_GAMES = 'whitelabel/lobby/config/games';
export const LOBBY_CONFIG_FOOTER = 'whitelabel/lobby/config/footer';
export const LOBBY_CONFIG_THEME = 'whitelabel/lobby/config/theme';
export const LOBBY_CONFIG_ANNOUNCEMENT = 'whitelabel/lobby/config/announcement';
export const LOBBY_CONFIG_BANNERS = 'whitelabel/lobby/config/banners';
export const LOBBY_CONFIG_STORE_IMAGES = 'whitelabel/lobby/config/store-images';
export const LOBBY_CONFIG_STORE_IMAGES_DEFAULT = 'whitelabel/lobby/config/store-images/default';
export const LOBBY_CONFIG_LANGUAGE = 'whitelabel/lobby/config/language';
export const LOBBY_CONFIG_LOADING = 'whitelabel/lobby/config/loading';

// WHITE LABEL
export const SETTING_IMAGE = 'setting/image';
export const SETTING_DESCRIPTION = 'setting/description';
export const EDIT_IMAGE = 'setting/image/update';
export const EDIT_THEME = 'setting/theme/update';
export const UPLOAD_IMAGE = 'setting/image/upload';
export const THEME_SELECTION = 'setting/lobby/theme';
export const UPDATE_THEME = 'setting/lobby/theme/update';
export const GET_WHITE_LABEL = 'whitelabel';

// RTP
export const GET_GAMES_RTP_LIST = 'rtp/list';
export const UPDATE_RTP = 'rtp/update';
export const UPDATE_AGENT_RTP = 'rtp/agent/update';

// MECHANIC
export const GET_PATTERN_LIST = 'pattern/list';
export const SET_PATTERN_MAINTENANCE = 'pattern/maintenance';

// RISK MANAGEMENT
export const GET_RISK_MANAGEMENT_LIST = 'risk-management/config/fetch/games';
export const UPDATE_CONFIGS_RISK = 'risk-management/config/game';

// DOMAIN POOL
export const DOMAIN_POOL_LIST = 'domain-pool/list';
export const DOMAIN_POOL_ADD = 'domain-pool/add';
export const DOMAIN_POOL_UPDATE = 'domain-pool/update';

// CAMPAIGN
export const CAMPAIGN_LIST = 'campaign/get';
export const CAMPAIGN_ADD = 'campaign/create';
export const CAMPAIGN_UPDATE = 'campaign/update';
export const CAMPAIGN_DELETE = 'campaign/delete';

// FAQ
export const FAQ_LIST = 'faq/list';
export const FAQ_UPDATE = 'faq/update';
export const FAQ_RESPONSE_CODE = 'faq/response-code';
export const FAQ_RESPONSE_CODE_UPDATE = 'faq/response-code';

// SECRET
export const AMBSLOT_SECRET = process.env.VUE_APP_AMBSLOT_SECRET;

// public key
export const PUBLIC_KEY_HEADER = process.env.VUE_APP_PUBLIC_KEY_HEADER;
